const voice = {
  // 更改房间模式
  changeModel: `/authApi/voice/v1/room/changeModel`,
  // 创建房间
  createroom: `/authApi/voice/v1/room/createroom`,
  // 修改房间
  editRoom: `/authApi/voice/v1/room/editRoom`,
  // 加入房间
  joinroom: `/authApi/voice/v2/room/joinroom`,
  // 离开房间
  leaveroom: `/authApi/voice/v1/room/leaveroom`,
  // 根据外显id获取房间id
  idByShowRoom: `/authApi/voice/v1/room/idByShowRoom`,
  // 房间信息搜索
  findRandomLiveRoom: `/authApi/voice/v2/room/findRandomLiveRoom`,
  // 清洗房间人员数据
  tidyActiveRoom: `/authApi/voice/v1/tidyActiveRoom`,
  // 全员禁言
  allBanned: `/authApi/voice/v1/allBanned`,
  // 禁言操作
  banOperate: `/authApi/voice/v1/banOperate`,
  // 禁麦操作
  closeMicOperate: `/authApi/voice/v1/closeMicOperate`,
  // 关注/取关用户
  follow: `/authApi/voice/v1/follow`,
  // 心跳检测
  heart: `/authApi/voice/v1/heart`,
  // 心跳检测 V2
  heartV2: `/authApi/voice/v2/heart`,
  // 在线观众列表 V2
  roomAudienceV2: `/authApi/voice/v2/room/audience`,
  // 禁言列表
  getIsBannedPage: `/authApi/voice/v1/pc/getIsBannedPage`,
  // 判断人员是否在房间中
  isInRoom: `/authApi/voice/v1/isInRoom`,
  // 踢出房间
  kickOut: `/authApi/voice/v1/kickOut`,
  // 上下麦操作
  micOperate: `/authApi/voice/v1/micOperate`,
  // 获取麦上人员列表
  micPersonList: `/authApi/voice/v1/micPersonList`,
  // 获取人员信息
  normalPerson: `/authApi/voice/v1/normalPerson`,
  // 在线观众列表
  onlinePerson: `/authApi/voice/v1/onlinePerson`,
  // 进入房间信息
  roomDetail: `/authApi/voice/v1/roomDetail`,
  // 屏蔽操作
  shieldMicOperate: `/authApi/voice/v1/shieldMicOperate`,
  // 分类接口
  categoryList: `/authApi/voice/v1/category/list`,
  // 创建子级房间列表
  createSonRoom: `/authApi/voice/v1/pc/createSonRoom`,
  // 获取子级房间列表
  getSonRoomList: `/authApi/voice/v1/pc/getSonRoomList`,
  // 删除子级房间
  removeRoom: `/authApi/voice/v1/room/removeRoom`,
  // 房间管理-成员列表
  memberList: `/authApi/voice/v1/room/member`,
  // 房间管理-设为管理员
  setUpManage: `/authApi/voice/v1/room/manager/setUp`,
  // 房间管理-撤销管理员
  revokeManage: `/authApi/voice/v1/room/manager/revoke`,
  // 房间管理-设为会员
  setUpMember: `/authApi/voice/v1/room/member/setUp`,
  // 房间管理-撤销会员
  revokeMember: `/authApi/voice/v1/room/member/revoke`,
  // 推荐房间列表
  getRecommendRoom: `/authApi/voice/v1/pc/getRecommendRoom`,
  // 我的房间
  getMyRoom: `/authApi/voice/v1/room/getMyRoleRoomPage`,
  // 最近访问
  browse: `/authApi/voice/v1/room/recently/browse`,
  // 创建房间
  myCreateroom: `/authApi/voice/v1/pc/createBoxRoom`,
  // 我创建的房间
  myCreateroomList: `/authApi/voice/v1/pc/getMyRoom`,
  // 搜索语音房关键词
  searchVoice: `/userApi/v1/Essearch/searchVoice`,
  // 获取oss临时上传参数
  getOssSign: `/liveApi/api/v3/Anchor/getOssSign`,
  // 房间设置
  roomSetter: `/authApi/voice/v1/room/roomSetter`,
  // 房间设置回显
  roomSetterShow: `/authApi/voice/v1/room/roomSetterShow`,
  // 单人调度
  singleDispatch: `/authApi/voice/v1/singleDispatch`,
  // 批量调度
  batchDispatch: `/authApi/voice/v1/batchDispatch`,
  // 语音房直播间规则 - 范昂 ? 林加汉
  queryLiveVoiceRuleDesc: `/authApi/voice/v1/queryLiveVoiceRuleDesc`,
  // 语音房直播间主播人气榜 - 范昂
  queryLiveVoiceAnchorRankList: `/authApi/show/v1/queryLiveVoiceAnchorRankList`,
  // 语音房直播间用户贡献榜 - 范昂
  queryLiveVoiceUserRankList: `/authApi/show/v1/queryLiveVoiceUserRankList`,
  // PC获取语音开播数据 - 刘阳
  beginVoiceLiveData: `/liveApi/api/v3/Anchor/beginVoiceLiveData`,
  // 设置房间私聊公聊消费元宝数 - 白金泽
  setVoiceRoomChatConfig: `/authApi/voice/v1/setRoomConsume`,
  // 公私聊前判断是否满足消费 - 白金泽
  isSatisfyLimitByConsume: `/authApi/voice/v1/isSatisfyLimitByConsume`,
  // 发起私聊 - 白金泽
  sendPrivateChatByUser: `/authApi/voice/v1/sendPrivateChatByUser`,
  // 撤回消息
  msgRecall: `/authApi/voice/v1/room/msgRecall`
};

export default voice;
